import React, { useState } from "react";

import ButtonActionIcon from "../../BuilderComponents/ButtonActionIcon";

const StateOrActivityChangeLogic = ({ logic, selectionObj, type, editJob, deleteJob }) => {
  const [isStateChangeLogicOpen, setIsStateChangeLogicOpen] = useState(true);

  const IDKey = type === "state" ? "state_id" : "activity_id";

  const toggleStateChangeLogic = () => {
    setIsStateChangeLogicOpen((prevState) => !prevState);
  };

  let heading = "State Change Logic";
  if (IDKey === "activity_id") {
    heading = "Next Activity Logic";
  }

  function getNameFromSelectedObj(selectedObj, logicItem, idKey = "state_id") {
    const match = selectedObj.find((item) => item.id === logicItem[idKey]);
    return match?.name;
  }

  return (
    <div className={logic.length === 0 ? "activity_select_top_block empty-state" : "activity_select_top_block"}>
      <div className="post_activity_top" onClick={toggleStateChangeLogic}>
        <div
          className="section_sub_heading"
          style={{ marginBottom: "0px", textTransform: "capitalize", display: "flex", gap: "8px" }}
        >
          {heading}
        </div>
      </div>

      {isStateChangeLogicOpen && (
        <div className="state_changeLogic_container">
          {logic[IDKey] && (
            <div className="state_changeLogic_inputs">
              <div className="icons">
                <ButtonActionIcon type="edit" onClick={editJob} />
                <ButtonActionIcon type="delete" onClick={deleteJob} />
              </div>
              <div>
                <label className="builder_label font_weight_normal" style={{ color: "var(--builder-light-text)" }}>
                  {type} :{" "}
                </label>
                {/*{selectionObj[logic[IDKey]] && (*/}
                {/*  <label className="builder_label">{selectionObj[logic[IDKey]]?.name}</label>*/}
                {/*)}*/}
                {selectionObj && (IDKey === "state_id" || IDKey === "activity_id") && (
                  <label className="builder_label font_size_small">
                    {getNameFromSelectedObj(selectionObj, logic, IDKey)}
                  </label>
                )}
              </div>
              <div>
                <label className="builder_label font_weight_normal">Logic : </label>
                <label className="builder_label font_size_small" style={{ textTransform: "none" }}>
                  {logic.condition}
                </label>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StateOrActivityChangeLogic;
